<template>
  <div
    v-if="critereRecherche"
    class="columns is-multiline is-main-content is-marginless is-paddingless">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcritureComptable.filtre.journaux')">
            <qd-taginput type='is-primary' v-model="critereRecherche.journaux"></qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="critereRecherche.dateComptable"
            :label="$t('listeEcritureComptable.filtre.dateComptable')">
          </input-periode>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcritureComptable.filtre.comptesComptables')">
            <qd-taginput type='is-primary' v-model="critereRecherche.comptesComptables">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcritureComptable.filtre.tiers')">
            <qd-taginput
              v-model="tiersSelected"
              :data="filteredTagsTiers"
              :loading="isFetchingTiers"
              @typing="getfilteredTiers"
              autocomplete
              icon="magnify"
              type="is-primary"
              field="nomCommercial">
              <template slot-scope="props">
                <div class="media">
                  <div class="media-content">
                    <b>{{ props.option.nomCommercial }}</b>
                    <span v-if="props.option.adresseString"
                      class="is-size-9 is-white-space-normal">
                      <br>
                      {{ props.option.adresseString }}
                    </span>
                    <span v-if="props.option.compteComptable"
                      class="is-size-9">
                      <br>
                      {{ props.option.compteComptable }}
                    </span>
                  </div>
                </div>
              </template>
              <template slot="empty">
                <div v-if="!isFetchingTiers">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <agence-tag-input
                      :label="$t('listeEcritureComptable.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="critereRecherche.agencesIds">
          </agence-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeEcritureComptable.filtre.valide')">
            <b-select v-model="critereRecherche.valide" expanded>
              <option :value="null"></option>
              <option :value="true">{{$t('general.oui')}}</option>
              <option :value="false">{{$t('general.non')}}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
            v-model="typeEcritureSelected"
            :label="$t('listeEcritureComptable.filtre.typeEcriture')"
            :items="constantes.LISTE_TYPE">
          </libelle-tag-input>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.appliquer')}}
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import genererCritereRecherche from '@/services/compta/ecritureComptable/genererCritereRechercheEcritureComptable';
import { getAll } from '@/api/tiers/index';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import messageErreur from '@/services/general/messageErreur';
import { SET_CRITERE } from '@/store/modules/compta/ecritureComptable-mutation-type';
import inputPeriode from '@/components/general/inputPeriode';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import { LISTE_TYPE } from '@/configuration/compta/ecritureConf';

const Societe = createNamespacedHelpers('societe');
const EcritureComptable = createNamespacedHelpers('ecritureComptable');

export default {
  components: {
    inputPeriode,
    libelleTagInput,
    agenceTagInput,
  },
  data() {
    return {
      critereRecherche: null,
      filteredTagsTiers: [],
      isFetchingTiers: false,
      constantes: {
        LISTE_TYPE,
      },
      tiersSelected: [],
      typeEcritureSelected: [],
    };
  },
  computed: {
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...EcritureComptable.mapGetters({
      criteresRechercheFromStore: 'criteresRecherche',
    }),
  },
  methods: {
    ...EcritureComptable.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    viderCritere() {
      this.critereRecherche = cloneDeep(genererCritereRecherche());
      this.tiersSelected = [];
      this.typeEcritureSelected = [];
    },
    appliquerCritere() {
      this.critereRecherche.tiers = this.tiersSelected;
      this.critereRecherche.typesEcriture = this.typeEcritureSelected.map((type) => {
        return type.code;
      });
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    getfilteredTiers: debounce(async function getClients(search) {
      this.filteredTagsTiers = [];
      if (!search) return;
      this.isFetchingTiers = true;
      try {
        const clients = (await getAll(
          {
            query: {
              auto: search,
              societeId: this.societeActiveId,
              archive: false,
            },
          },
        )).data.result.items.filter(t => t.compteComptable);
        clients.forEach((client) => {
          if (adressFullStringGetter(client.adressePostale, false) !== '') {
            client.adresseString = adressFullStringGetter(client.adressePostale, false);
          }
        });
        this.filteredTagsTiers = clients.filter((client) => {
          return !this.tiersSelected.map(
            tiersSelected => tiersSelected.id,
          ).includes(client.id);
        });
        this.isFetchingTiers = false;
      } catch (e) {
        this.isFetchingTiers = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    initializeFiltre() {
      this.critereRecherche = cloneDeep(this.criteresRechercheFromStore);
      this.tiersSelected = this.critereRecherche.tiers;
      if (this.critereRecherche.typesEcriture) {
        this.typeEcritureSelected = this.constantes.LISTE_TYPE.filter((etat) => {
          return this.critereRecherche.typesEcriture.includes(etat.code);
        });
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
